import {caretDownSvg as Icon__small__caretDownSvg} from '../Icon__small/Icon__small--caretDown.js';

export var caretDown = {
  name: 'caretDown',
  category: 'icon',
  colorable: true,
  svg: Icon__small__caretDownSvg,
};
